import { Theme, webDarkTheme, webLightTheme } from '@fluentui/react-components';

// Showell brand colours — kept local because showell-commons/theme is a
// React Native file that cannot be bundled by webpack without aliasing.
// These must be kept in sync with colors.brandBlue / brandBlueLight in
// packages/showell-commons/src/commons/theme.ts.
const colors = {
  brandBlueLight: '#5e7ee8', // primary-400
  brandBlue: '#1e42d1', // primary-500
};

const FONT_REGULAR = '"Aptos", "Segoe UI", "Helvetica Neue", sans-serif';

function createShowellTheme(baseTheme: Theme, mode: 'light' | 'dark'): Theme {
  if (mode === 'dark') {
    return {
      ...baseTheme,
      fontFamilyBase: FONT_REGULAR,
      colorBrandForeground1: '#a9c0ff',
      colorBrandForeground2: '#c2d2ff',
      colorBrandBackground: colors.brandBlueLight,
      colorBrandBackgroundHover: '#6f8cf0',
      colorBrandBackgroundPressed: colors.brandBlue,
      colorBrandBackground2: '#21325f',
      colorBrandBackground2Hover: '#294073',
      colorBrandStroke1: '#7d99f3',
      colorBrandStroke2: '#90a8f6',
      colorNeutralBackground1: '#141a28',
      colorNeutralBackground1Hover: '#1b2233',
      colorNeutralBackground2: '#0f1520',
      colorNeutralBackground3: '#20283b',
      colorNeutralBackground4: '#2b3550',
      colorNeutralForeground1: '#f7f8fb',
      colorNeutralForeground2: '#c4cede',
      colorNeutralStroke1: '#2d3955',
      colorNeutralStroke2: '#394666',
      colorCompoundBrandBackground: colors.brandBlueLight,
      colorCompoundBrandBackgroundHover: '#6f8cf0',
      colorCompoundBrandBackgroundPressed: colors.brandBlue,
      colorCompoundBrandForeground1: '#ffffff',
      colorCompoundBrandStroke: '#86a0f5',
      colorTransparentBackground: 'transparent',
    };
  }

  return {
    ...baseTheme,
    fontFamilyBase: FONT_REGULAR,
    colorBrandForeground1: colors.brandBlue,
    colorBrandForeground2: '#3657d9',
    colorBrandBackground: colors.brandBlue,
    colorBrandBackgroundHover: '#3657d9',
    colorBrandBackgroundPressed: '#1735aa',
    colorBrandBackground2: '#edf2ff',
    colorBrandBackground2Hover: '#e1e8ff',
    colorBrandStroke1: '#6281eb',
    colorBrandStroke2: colors.brandBlue,
    colorNeutralBackground1: '#f6f7fb',
    colorNeutralBackground1Hover: '#eef1f8',
    colorNeutralBackground2: '#ffffff',
    colorNeutralBackground3: '#f1f3f8',
    colorNeutralBackground4: '#e8ecf5',
    colorNeutralForeground1: '#151a23',
    colorNeutralForeground2: '#4c596f',
    colorNeutralStroke1: '#d9dfec',
    colorNeutralStroke2: '#c3ccde',
    colorCompoundBrandBackground: colors.brandBlue,
    colorCompoundBrandBackgroundHover: '#3657d9',
    colorCompoundBrandBackgroundPressed: '#1735aa',
    colorCompoundBrandForeground1: '#ffffff',
    colorCompoundBrandStroke: colors.brandBlue,
    colorTransparentBackground: 'transparent',
  };
}

export const showellLightTheme = createShowellTheme(webLightTheme, 'light');
export const showellDarkTheme = createShowellTheme(webDarkTheme, 'dark');

export function getInitialTaskpaneTheme(): Theme {
  try {
    return Office.context.officeTheme?.isDarkTheme
      ? showellDarkTheme
      : showellLightTheme;
  } catch {
    return showellLightTheme;
  }
}
